import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import ProfessionSpecialty from '../../../components/ProfessionSpecialty/index';
import validationSchema from './validation';
import ValidatesFormWith from '../../../utils/ValidatesFormWith';
import Input from '../../../components/Input';
import Countries from '../../../utils/Countries';
import Select from '../../../components/Select';
import Birthday from '../../../components/Birthday';
import Textarea from '../../../components/Textarea';
import UploadImageField from '../../../components/UploadImageField';
import Checkbox from '../../../components/Checkbox';
import { Link } from 'react-router-dom';

class RegisterForm extends React.PureComponent {
  process = (values) => {
    const user = {
      name: values.name,
      lastname: values.lastname,
      email: values.email,
      password: values.password,
      birthday: values.birthday.format('YYYY-MM-DD'),
      profession: values.profession,
      nationality: values.nationality,
      residence: values.residence,
      specialty: values.specialty,
      biography: values.biography,
      images: values.images,
    };

    this.props.onCreateArtist(user);
  };

  render() {
    const { error, saving } = this.props;

    return (
      <Formik
        initialValues={{
          name: '',
          birthday: undefined,
          lastname: '',
          email: '',
          password: '',
          images: [],
          profession: '',
          nationality: '',
          residence: '',
          specialty: '',
          biography: '',
          ToS: false,
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema)}
        validateOnChange={false}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            <div className="search-contents-sidebar">
              <div className="row">
                {error && <p className="red">{error}</p>}
                <div className="col-md-6">
                  <Input
                    label="Nombre"
                    name="name"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Apellido"
                    name="lastname"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Correo electrónico"
                    name="email"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Contraseña"
                    name="password"
                    type="password"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <Select
                    label="Nacionalidad"
                    name="nationality"
                    placeholder="Seleccione su nacionalidad"
                    options={Countries}
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    label="País de residencia"
                    name="residence"
                    placeholder="Seleccione país de residencia"
                    options={Countries}
                  />
                </div>
                <div className="col-md-4">
                  <Birthday
                    label="Fecha de nacimiento"
                    name="birthday"
                  />
                </div>
              </div>
              <div className="row">
                <ProfessionSpecialty />
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Textarea
                    label="Reseña CV"
                    name="biography"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <UploadImageField
                    label="Imágenes"
                    name="images"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <Checkbox
                    label="¿Deseas que tu edad aparezca en tu perfíl?"
                    name="showAge"
                  >
                    Si, deseo que aparezca
                  </Checkbox>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <Checkbox
                    label="Términos y condiciones"
                    name="ToS"
                    error="Debes aceptar los términos y condiciones antes de registrarte"
                  >
                    <Link to="/tos" className="tos-checkbox" target="_blank"> Acepto los términos y condiciones</Link>
                  </Checkbox>
                </div>
              </div>

              <div className="m-b-md m-t-md">
                <button disabled={saving} type="submit" className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Registrarme</span>
                  <div className="clear" />
                </button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

RegisterForm.propTypes = {
  onCreateArtist: PropTypes.func,
};

RegisterForm.defaultProps = {
  onCreateArtist: () => {},
};

export default RegisterForm;



// WEBPACK FOOTER //
// ./src/containers/General/RegisterPage/Form.js